import { ActivityHistory } from '@user/features/Activity/state'
import * as React from 'react'
import { TreeNode } from '../TreeNode/TreeNode'
import { VerticalLineTableRow } from '../VerticalLine/VerticalLineTableRow'
import { useMapViewFeatureEnabled } from '@user/store/tenantFeatures/hooks/useMapViewFeatureEnabled'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'
import { ActivityHistoryType } from '@user/features/Activity/ActivityHistory/constants'

type Props = {
  history: ActivityHistory[]
}

export function ActivityHistoryList(props: Props) {
  const { history } = props
  const mapViewEnabled = useMapViewFeatureEnabled()
  const knockStatusEnabled = useD2DKnockEnabled()

  const visibleHistory = React.useMemo(() => {
    return history.filter((el) => {
      if (el.activityHistoryType === ActivityHistoryType.KnockStatusUpdate) {
        return mapViewEnabled && knockStatusEnabled
      }
      return true
    })
  }, [history, mapViewEnabled, knockStatusEnabled])

  return (
    <>
      {visibleHistory.map((el, index) => (
        <React.Fragment key={index}>
          <TreeNode historyElement={el} />
          {visibleHistory.length > 1 && index < visibleHistory.length - 1 && (
            <VerticalLineTableRow />
          )}
        </React.Fragment>
      ))}
    </>
  )
}
